"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StudentWorkModal = void 0;
var react_1 = __importDefault(require("react"));
var Icon_1 = __importDefault(require("../../../basics/Icon"));
var typography_1 = require("../../../typography");
var BaseModal_1 = __importDefault(require("../BaseModal"));
var Link_1 = __importDefault(require("../../../navigation/Link"));
var styles_1 = require("./styles");
var ICON_SIZE = { small: 32, medium: 32, large: 32 };
var StudentWorkModal = function (_a) {
    var title = _a.title, by = _a.by, type = _a.type, websiteUrl = _a.websiteUrl, prettyUrl = _a.prettyUrl, image = _a.image, onClose = _a.onClose, previousUrl = _a.previousUrl, nextUrl = _a.nextUrl, commonProps = __rest(_a, ["title", "by", "type", "websiteUrl", "prettyUrl", "image", "onClose", "previousUrl", "nextUrl"]);
    return (react_1.default.createElement(BaseModal_1.default, { title: title, onClose: onClose }, function (_a) {
        var ref = _a.ref, rest = __rest(_a, ["ref"]);
        return (react_1.default.createElement(styles_1.Wrapper, __assign({ "data-component-name": "StudentWorkModal" }, commonProps, rest, { ref: ref }),
            react_1.default.createElement(styles_1.Box, null,
                react_1.default.createElement(styles_1.Header, null,
                    react_1.default.createElement(typography_1.Body, { color: "WHITE", level: "3", inline: true }, title),
                    ' ',
                    react_1.default.createElement(typography_1.Body, { color: "GREY_70", level: "3", inline: true },
                        "by ",
                        by,
                        websiteUrl && (react_1.default.createElement(react_1.default.Fragment, null,
                            ' ',
                            react_1.default.createElement("span", null, "\u2013"),
                            ' ',
                            react_1.default.createElement(Link_1.default, { href: websiteUrl, color: "GREY_70", hoverColor: "GREY_50", isExternal: true }, prettyUrl || websiteUrl)))),
                    react_1.default.createElement(styles_1.CloseWrapper, { onClick: onClose, color: "WHITE", hoverColor: "GREY_50" },
                        react_1.default.createElement(Icon_1.default, { name: "close" }))),
                react_1.default.createElement(styles_1.Content, null, type === 'WEBSITE' ? react_1.default.createElement(styles_1.Website, { src: websiteUrl }) : image && react_1.default.createElement(styles_1.Img, __assign({}, image)))),
            react_1.default.createElement(styles_1.Nav, null,
                previousUrl && (react_1.default.createElement(styles_1.NavButton, { href: previousUrl, direction: "prev" },
                    react_1.default.createElement(Icon_1.default, { name: "arrow-left", color: "WHITE", size: ICON_SIZE }))),
                nextUrl && (react_1.default.createElement(styles_1.NavButton, { href: nextUrl, direction: "next" },
                    react_1.default.createElement(Icon_1.default, { name: "arrow-right", color: "WHITE", size: ICON_SIZE }))))));
    }));
};
exports.StudentWorkModal = StudentWorkModal;
exports.default = exports.StudentWorkModal;
